import React from "react";
import { IoClose } from "react-icons/io5";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { IoWarningOutline } from "react-icons/io5";
const HintContainer = ({
  className,
  hints,
  handleClickHint,
  penalty,
  hintsUsed,
}) => {
  return (
    <div className="w-full h-full flex 2xl:-mt-10 xl:-mt-12 lg:-mt-16 justify-center ">
      <div className="2xl:w-[520px] w-[480px] xl:pt-8 pt-6 xl:pb-10 pb-8  border-2 border-[#434343] flex flex-col items-center bg-[#000] rounded-[30px]">
        <div className="flex relative flex-row w-full relative items-start">
          <div className="flex w-full flex-col items-center sm:gap-y-2 gap-y-1">
            <h1 className="sm:text-2xl xs:text-xl text-base text-[#b2b2b2] font-bold">
              Crypto Hunt Hints
            </h1>
            <p className="xs:text-xs text-[10px] font-normal">
              Use hints to be correct and win rewards
            </p>
          </div>
          {!!(hints?.length - 2 === hintsUsed?.length) && (
            <h1 className="absolute sm:text-base xs:text-xs text-[10px] text-[#200052] left-1/2 -translate-x-1/2 xl:-bottom-8 -bottom-6">
              All hints are used.
            </h1>
          )}
        </div>
        <div className="flex w-full xl:px-6  px-4 flex-row gap-x-2  mt-10 items-center">
          <HintCard
            title={"Available Used"}
            totalHints={hints?.length - 2}
            availableHints={hintsUsed?.length}
            module={"hint"}
            icon={
              <IoIosInformationCircleOutline className="text-base text-[#200052]" />
            }
          />
          <HintCard
            title={"Penalty"}
            penalty={penalty}
            module={"penalty"}
            icon={<IoWarningOutline className="text-base text-[#200052]" />}
          />
        </div>
        <div className="flex w-full mt-4 flex-row xl:px-6 px-4 justify-between flex-wrap gap-y-2">
          {hints?.map((hint) => {
            return (
              <HintDetailsCard
                key={hint?._id}
                id={hint?._id}
                title={hint?.title}
                icon={hint?.icon}
                handeClick={() => handleClickHint(hint?.penalty, hint?._id)}
                penalty={hint?.penalty}
                used={hintsUsed?.includes(hint?._id)}
                value={hint?.value}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HintContainer;

const HintCard = ({
  icon,
  title,
  penalty,
  module,
  totalHints,
  availableHints,
  className,
}) => {
  return (
    <div
      className={`${className} w-full flex justify-between items-center flex-row bg-[#1e1e1e] xl:px-6 sm:px-4 xs:px-3 px-2  py-2 border-[0.2px] border-[#434343]/70 rounded-full`}
    >
      <div className="flex sm:text-[14px] xs:text-xs text-[10px] items-center flex-row sm:gap-x-2 gap-x-1">
        {icon}
        <h1 className="text-[#b2b2b2] font-semibold">{title}</h1>
      </div>

      <h1
        className={`md:text-base sm:text-[13px] xs:text-[11px] text-[10px] font-bold ${
          module === "hint" ? "text-white" : " text-[#200052]"
        }`}
      >
        {module === "hint" ? (
          <>
            {availableHints}/{totalHints}
          </>
        ) : (
          <>-{penalty} pts</>
        )}
      </h1>
    </div>
  );
};
const HintDetailsCard = ({
  title,
  handeClick,
  icon,
  penalty,
  used,
  value,
  id,
}) => {
  const Icon = icon;
  return (
    <div
      onClick={handeClick}
      role="button"
      className={` 
      
        ${
          !used
            ? `${
                penalty !== 0 &&
                "hover:bg-[#141414] active:bg-[#200052] border-0 group"
              } `
            : "opacity-60"
        } border-[0.8px] border-[#434343]  transition-all duration-150 linear flex flex-col gap-y-0 items-start  w-[calc(50%-4px)] rounded-[8px] xl:p-4 xs:p-3 p-2 bg-[#1e1e1e]`}
    >
      <div className="flex  flex-row w-full items-start justify-between">
        <div className="flex flex-row gap-x-2 items-center">
          <Icon
            className={`${!used && "group-active:text-white"} text-[#200052]`}
          />
          <h1 className="sm:text-[14px] text-xs text-[10px] capitalize text-white">
            {title}
          </h1>
        </div>
        {penalty !== 0 && (
          <span
            className={`sm:text-base text-[8px] ${
              !used && "group-active:text-white"
            } text-[#200052] font-semibold`}
          >
            -{penalty} pts
          </span>
        )}
      </div>
      <div className=" h-fit">
        {used ? (
          <p className="sm:text-xs text-[8px] mt-1 w-full">{value}</p>
        ) : (
          <>
            {penalty === 0 ? (
              <p className="text-xs mt-1 w-full">{value}</p>
            ) : (
              <span className="text-xs text-[#cccccc]">Click to reveal</span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
